import { api, type Season } from '../../api/public'
import { useApi, type Async } from '../../components/useApi'

/**
 * The season a view is showing: the one named in the URL, else the current one.
 *
 * A member arriving at "the standings" means this season's, so the bare route
 * has no id in it. **A finished season is still browsable** (FR-002), and it is
 * reached by its own URL — which is also what a person shares.
 */
export function useSeason(seasonId?: string): Async<Season> {
  const seasons = useApi((s) => api.seasons(s), [])
  if (seasons.state !== 'ready') return seasons

  const wanted = seasonId ? Number(seasonId) : 0
  if (wanted) {
    const named = seasons.data.find((s) => s.id === wanted)
    return named
      ? { state: 'ready', data: named }
      : { state: 'error', error: new Error(`there is no season ${wanted}`) }
  }
  const current = seasons.data.find((s) => s.is_current) ?? seasons.data[0]
  if (!current) {
    return { state: 'error', error: new Error('the league has no seasons yet') }
  }
  return { state: 'ready', data: current }
}
